export interface ExpirationYear {
  readonly value: string;
  readonly label: string;
}

export const DEFAULT_EXPIRATION_YEARS_AHEAD = 15;

export function generateExpirationYears(
  yearsAhead: number = DEFAULT_EXPIRATION_YEARS_AHEAD,
  now: Date = new Date()
): ExpirationYear[] {
  if (yearsAhead < 0) {
    return [];
  }
  const currentYear = now.getFullYear();
  const result: ExpirationYear[] = [];
  for (let i = 0; i <= yearsAhead; i++) {
    const fullYear = currentYear + i;
    result.push({
      value: fullYear.toString().slice(-2),
      label: fullYear.toString(),
    });
  }
  return result;
}
